import { Loadable } from '../..';
import { PreferencesAppState } from './types';

export const getAutoPlayPreference = ({ preferences }: PreferencesAppState): Loadable<boolean> =>
    preferences.autoPlay;
